<template>
  <div class="cso-tariff-offer sliding">
    <h3>{{ $t(headerText) }}</h3>
    <div class="close" @click="close()" data-cy="close-btn" aria-label="Schließen" role="img"></div>
    <img
        :src="`/static/images/${image}`"
        :alt="$t(headerText)"
        :class="imageClass" />
    <p class="first"
        v-if="firstText" v-html="$t(firstText)">
    </p>
    <p class="second"
        v-if="secondText && secondText !== 'null'">
      {{ $t(secondText) }}
    </p>
    <div class="submit" @click="submit()" data-cy="to-offer-btn">{{  $t(linkText) }}</div>
  </div>
</template>

<script lang="ts">
export default {
  name: "CsoTariffOffer",

  props: {
    headerText: {
      type: String,
      required: false,
      default: 'tariffOffer.headline'
    },
    image: {
      type: String,
      required: false,
      default: 'tariff-offer.jpg'
    },
    firstText: {
      type: String,
      required: false,
      default: 'tariffOffer.text1'
    },
    secondText: {
      type: String,
      required: false,
      default: 'tariffOffer.text2'
    },
    linkText: {
      type: String,
      required: false,
      default: 'tariffOffer.submit'
    }
  },

  computed: {
    imageClass () {
      return this.image.split('.')[0]
    }
  },

  methods: {
    submit () {
      this.$emit('submit')
    },
    close () {
      this.$el.classList.add('sliding')
      setTimeout(() => this.$emit('close'), 300)
    },
  },
  mounted () {
    setTimeout(() => this.$el.classList.remove('sliding'))
  }
}
</script>

<style lang="scss">
.cso-tariff-offer {
  position: fixed;
  width: 280px;
  bottom: 0;
  right: 10px;
  background-color: #f2f7fb;
  color: #1e324f;
  z-index: 10;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  font-family: $font-family-regular;
  border-radius: 4px;
  overflow: hidden;
  user-select: none;
  transition: transform 300ms;

  &.sliding {
    transform: translateY(100%);
  }

  h3 {
    background-color: #2071B5;
    margin: 0;
    padding: 5px 34px 5px 10px;
    color: white;
    font-weight: lighter;
    font-size: 15px;
  }

  .close {
    position: absolute;
    top: 7px;
    right: 7px;
    background-image: url(/static/icons/close-white.svg);
    background-size: cover;
    cursor: pointer;
    width: 20px;
    height: 20px;
  }

  .close:hover {
    background-color: #578cba;
  }

  img {
    width: 100%;
    max-height: 186px;
    object-fit: cover;

    &.teaser-solar {
      object-position: 0 -73px;
    }
  }

  p.first {
    margin: 8px 10px 4px 10px;
  }

  p.second {
    margin: 0 10px;
    font-weight: bold;
  }

  .submit {
    background-color: #ffda00;
    border-radius: 20px;
    text-align: center;
    padding: 6px;
    cursor: pointer;
    margin: 16px 10px 12px 10px;;
    font-size: 12px;
  }

  .submit:hover {
    background-color: #fce873;
  }
}
</style>
